import React from 'react';
import { OnHoldViewStore } from 'modules/order/stores';
import { OnHoldTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new OnHoldViewStore(rootStore, componentProps), 'onHoldViewStore')
class OnHold extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <OnHoldTemplate {...this.props} />;
	}
}

export default OnHold;



// WEBPACK FOOTER //
// ./src/modules/order/pages/OnHold.jsx